
export var MenuType = {
	Status: 0,
	Config: 1,
	Info: 2,
	Password: 3,
	AccessGranted: 4,
	AccessDenied: 5,
    ConfigEdit: 6,
    ChangeConfirm: 7,
    ConfigSelect: 8,
    PingIP: 9,
    PingName: 10,
    OutputTest: 11,
    InputTest: 12,
    ReaderTest: 13,
    ReaderSampling: 14,
    DeleteEventsConfirm: 15,
    EraseFlashConfirm: 16,
    BoardType: 17,
    BoardAddress: 18
};

export var ConfigType = {
	Ip: 0,
	Int: 1,
	String: 2,
    List: 3,
    Test: 4,
    Confirm: 5
};

export var Menus = {
    0: {
        screens: [
            { line1: (t) => "Version", line2: (t) => "V" + t.firmwareVersion },
            { line1: (t) => "DHCP Bound", line2: (t) => t.ipAddress },
            { line1: (t) => "Connected with", line2: (t) => "Server IP" },
            {
                line1: (t) => {
                    var d = new Date();
                    return "Date: " + d.getFullYear() + "," + String(d.getMonth() + 1).padStart(2, '0') + "," + String(d.getDate()).padStart(2, '0')
                },
                line2: (t) => {
                    var d = new Date();
                    return "Time: " + String(d.getHours()).padStart(2, '0') + ":" + String(d.getMinutes()).padStart(2, '0') + ":" + String(d.getSeconds()).padStart(2, '0') + " D"
                }
            },
            { line1: (t) => t.panelName, line2: (t) => t.siteName },
            { line1: (t) => "Network Name:", line2: (t) => t.networkName },

            { line1: (t) => "Door1 State", line2: (t) => "Closed" },
            { line1: (t) => "Door1 Time Zone", line2: (t) => "Card or Pin" },
            { line1: (t) => "Door2 State", line2: (t) => "Closed" },
            { line1: (t) => "Door2 Time Zone", line2: (t) => "Card or Pin" },
            { line1: (t) => "Door3 State", line2: (t) => "Closed" },
            { line1: (t) => "Door3 Time Zone", line2: (t) => "Card or Pin" },
            { line1: (t) => "Door4 State", line2: (t) => "Closed" },
            { line1: (t) => "Door4 Time Zone", line2: (t) => "Card or Pin" },
            { line1: (t) => "Door5 State", line2: (t) => "Closed" },
            { line1: (t) => "Door5 Time Zone", line2: (t) => "Card or Pin" },
            { line1: (t) => "Door6 State", line2: (t) => "Closed" },
            { line1: (t) => "Door6 Time Zone", line2: (t) => "Card or Pin" },
            { line1: (t) => "Door7 State", line2: (t) => "Closed" },
            { line1: (t) => "Door7 Time Zone", line2: (t) => "Card or Pin" },
            { line1: (t) => "Door8 State", line2: (t) => "Closed" },
            { line1: (t) => "Door8 Time Zone", line2: (t) => "Card or Pin" },

            { line1: (t) => "SiteCodeCnt: " + t.siteCodeCount, line2: (t) => "UserCnt: " + t.userCount },
            { line1: (t) => "Power: 2A2", line2: (t) => "Normal" },
            { line1: (t) => "Battery: 11A", line2: (t) => "Not Exist" }
        ]
    },
    1: {
        screens: [
            { text: "Server IP Addr", type: ConfigType.Ip, prop: 'serverAddress', action: 4  },
            { text: "Server Port", type: ConfigType.Ip, prop: 'serverPort', action: 5 },
            { text: "Server Name", type: ConfigType.String, prop: 'serverName', action: 6 },
            { text: "Sever Conn Mode", type: ConfigType.List, prop: 'serverConnMode', items: ["Auto", "Server IP", "Server Name"], action: 7 },
            { text: "Panel Comm Mode", type: ConfigType.List, prop: 'panelCommMode', items: ["Static IP", "DHCP Client", "Reserved"], action: 8 },
            { text: "Panel IP Addr", type: ConfigType.Ip, prop: 'ipAddress', action: 9 },
            { text: "Panel SubnetMsk", type: ConfigType.Ip, prop: 'subnetMask', action: 10 },
            { text: "Panel Gateway", type: ConfigType.Ip, prop: 'defaultGateway', action: 11 },
            { text: "Panel DNS", type: ConfigType.Ip, prop: 'dns', action: 12 },
            { text: "Panel Run Mode", type: ConfigType.List, prop: 'panelRunMode', items: ["Normal", "Debug", "Diagnose"], action: 13 },
            { text: "HTTP Srver Mode", type: ConfigType.List, prop: 'httpServerMode', items: ["On Always", "On While Logof", "On For 10 min"] },
            { text: "Ping with IP", type: ConfigType.Test, screen: MenuType.PingIP },
            { text: "Ping with Name", type: ConfigType.Test, screen: MenuType.PingName },
            { text: "Output Test", type: ConfigType.Test, screen: MenuType.OutputTest },
            { text: "Input Test", type: ConfigType.Test, screen: MenuType.InputTest },
            { text: "Reader Test", type: ConfigType.Test, screen: MenuType.ReaderTest },
            { text: "Reader Sampling", type: ConfigType.Test, screen: MenuType.ReaderSampling },
            { text: "Delete Events", type: ConfigType.Confirm, screen: MenuType.DeleteEventsConfirm },
            { text: "Erase Flash Mem", type: ConfigType.Confirm, screen: MenuType.EraseFlashConfirm }
        ]
    },
    2: {
        screens: [
            { text: "Panel Name", value: (t) => t.panelName },
            { text: "Area Name", value: (t) => t.areaName },
            { text: "Panel Dev. ID", fullText: "Panel Device ID", value: (t) => t.panelId },
            { text: "Panel Run Mod", fullText: "Panel Run Mode", value: (t) => t.panelRunMode + ":" + Menus[1].screens[8].items[t.panelRunMode] },
            { text: "Default IP Ad", fullText: "Default IP Addr", value: (t) => t.ipAddress },
            { text: "Actual IP Add", fullText: "Actual IP Addr", value: (t) => t.ipAddress },
            { text: "Panel MAC Add", fullText: "Panel MAC Addr", value: (t) => t.panelMacAddress },
            { text: "Panel Gateway", value: (t) => t.defaultGateway },
            { text: "Panel DNS", value: (t) => t.dns },
            { text: "Panel Comm Mo", fullText: "Panel Comm Mode", value: (t) => t.panelCommMode + ":" + Menus[1].screens[3].items[t.panelCommMode] },
            { text: "Server IP Add", fullText: "Server IP Addr", value: (t) => t.serverAddress },
            { text: "Server Name", value: (t) => t.serverName },
            { text: "Server Port", value: (t) => t.serverPort },
            { text: "Srvr Conn Mod", fullText: "Server Conn Mode", value: (t) => t.serverConnMode + ":" + Menus[1].screens[2].items[t.serverConnMode] },
            { text: "Firmware Ver", fullText: "Firmware Version", value: (t) => t.firmwareVersion },
            { text: "HTTP Srvr Mod", fullText: "HTTP Server Mode", value: (t) => t.httpServerMode + ":" + Menus[1].screens[9].items[t.httpServerMode] },
        ]
    }
}

/* Menus
 * 
 * 
	- 01 Panel Name / PRS panel
	- 02 Area Name / Default Site
	- 03 Panel Dev. ID / Panel Device ID / 1
	- 04 Panel Run Mod[e] / 0:Normal
	- 05 Default IP Ad[dr] / 001.001.001.001
	- 06 Actual IP Add[r] / 192.168.002.142
	- 07 Panel MAC Add[r] / E8EB1FEE7D1
	- 08 Panel Sub[net]Mask / 255.255.255.000
	- 09 Panel Gateway / 192.168.002.001
	- 10 Panel DNS / 192.168.002.001
	- 11 Panel Comm Mo[de] / 1 :DHCP Client*
	- 12 Server IP Add[r] / 192.168.002.055*
	- 13 Server Name / SERVER-PC
	- 14 Server Port / 09876
	- 15 S[e]rv[e]r Conn Mod[e] / 1:Server IP*
	- 16 Firmware Ver[sion] / PMS V23012290*
	- 17 HTTP S[e]rv[e]r Mod[e] / 1:On Always
- Status Menu (Auto Rotate)
- Password Menu
	Setup Password?
	0000
	- Blink character when in view
	- Flash between * and number when in edit mode for password

	Access Granted

- Config Menu
	- Server IP Addr
	- Server Port
	- Server Name
	- Sever Conn Mode
	- Panel Comm Mode
	- Panel IP Addr
	- Panel SubnetMsk
	- Panel Gateway
	- Panel DNS
	- Panel Run Mode
	- HTTP Srver Mode
	- Ping with IP
        Ping Server IP
        192.168.002.010

        Time = 0ms
	- Ping with Name
        Ping Server Name
        SERVER-PC

        DNS Resolve Err
	- Output Test
        Board type
        1: Use Preset DB
        2: PRS-IO8
        3: PRS_TDM
        4: PRS_IO8_All
        5: PRS_TDM_All

        Board Address
        01 PRS_IO8
        Input Menu
        1: States
            D=Digital,o=open
            S=Sprvisd,c=cloz
            1 2 3 4 5 6 7 8
            _______________
        2: ADC Values
        3: Threshold_Hi
        4: Threshold_Low
        5: Threshd_Preset
        6: Threshd_Hi Chg
        7: Threshd_Lo Chg

        1 2 3 4 5 6
        0 0 0 0 0 0


	- Input Test
	- Reader Test
	- Reader Sampling
	- Delete Events
        Delete Events?
        Yes=Enter,No=Esc -> Canceled
	- Erase Flash Mem
        Erase Flash Mem?
        Yes=Enter,No=Esc -> Canceled

- Info Menu

- Edit Mode for values
- Blink character when in view
- Flash between * and number when in edit mode for password


*/